import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=6686522d&scoped=true&"
import script from "./address-form.vue?vue&type=script&lang=js&"
export * from "./address-form.vue?vue&type=script&lang=js&"
import style0 from "./address-form.vue?vue&type=style&index=0&id=6686522d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6686522d",
  null
  
)

export default component.exports